import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { List, Box, ListSubheader } from '@mui/material';
//
import { NavListRoot } from './NavList';
import useAdminInfoStore from 'src/store/admin';
import SvgIconStyle from 'src/components/SvgIconStyle';
import { PATH_DASHBOARD } from 'src/routes/paths';
import useProjectInfoStore from 'src/store/project';

// ----------------------------------------------------------------------

export const ListSubheaderStyle = styled((props) => <ListSubheader disableSticky disableGutters {...props} />)(({ theme }) => ({
  ...theme.typography.overline,
  paddingTop: theme.spacing(3),
  paddingLeft: theme.spacing(2),
  paddingBottom: theme.spacing(1),
  color: theme.palette.text.primary,
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

NavSectionVertical.propTypes = {
  isCollapse: PropTypes.bool,
  navConfig: PropTypes.array,
};

export default function NavSectionVertical({ navConfig, isCollapse = false, ...other }) {
  const { pathname } = useLocation();

  const { adminInfo } = useAdminInfoStore();
  const { projectInfo } = useProjectInfoStore();

  const menuItems = adminInfo?.Menu;

  const projectId = projectInfo?.ApplicationID;
  const projectTitle = `پروژه ${projectInfo?.ApplicationTitle}`;

  const newMenuItem = {
    ProfileUACMenuID: null,
    ProfileUACMenuProfileID: null,
    ProfileUACMenuTitle: projectTitle,
    ProfileUACMenuUrl: pathname?.includes('project/') ? '/' : '/null-pathname',
    ProfileUACMenuIcon: 'project',
    ProfileUACMenuIsDefaultRoute: null,
  };

  if (projectInfo) {
    if (menuItems[2]?.ProfileUACMenuTitle?.includes('پروژه')) {
      menuItems[2] = newMenuItem;
    } else {
      menuItems.splice(2, 0, newMenuItem);
    }
  } else {
    if (menuItems[2]?.ProfileUACMenuTitle?.includes('پروژه')) menuItems.splice(2, 1);
  }

  const manipulatedNavConfig = [
    {
      items: menuItems?.map((item) => {
        return {
          title: item?.ProfileUACMenuTitle,
          path: item?.ProfileUACMenuUrl,
          icon: <SvgIconStyle src={`/icons/ic_${item?.ProfileUACMenuIcon}.svg`} sx={{ width: 1, height: 1 }} />,
          ...(item?.ProfileUACMenuTitle === projectTitle && {
            children: [
              { title: 'گزارش کلی پروژه', path: PATH_DASHBOARD.general.projectReport(projectId) },
              { title: 'ویرایش', path: PATH_DASHBOARD.general.editProject(projectId) },
              { title: 'مدیریت پیکربندی', path: PATH_DASHBOARD.general.configLayout(projectId) },
              { title: 'مدیریت پروفایل', path: PATH_DASHBOARD.general.configProfile(projectId) },
              { title: 'فهرست بخش ها', path: PATH_DASHBOARD.general.appSectionList(projectId) },
              { title: 'مدیریت اعلان ها', path: PATH_DASHBOARD.general.notificationPopupList(projectId) },
              // { title: 'بسته محتواها', path: PATH_DASHBOARD.general.projectFeedList(projectId) },
              // { title: 'بنرها', path: PATH_DASHBOARD.general.notificationBannerList(projectId) },
              // { title: 'بنرها و اعلانات', path: PATH_DASHBOARD.general.notificationBannerTypeList(projectId) },
              { title: 'تورنومنت ها', path: PATH_DASHBOARD.general.duelList(projectId) },
              // { title: 'لیدربرد ها', path: PATH_DASHBOARD.general.leaderBoardList(projectId) },
              { title: 'بسته های اشتراک', path: PATH_DASHBOARD.general.subscribePackageList(projectId) },

              { title: 'گردونه ها', path: PATH_DASHBOARD.general.wheelList(projectId) },
              { title: 'بسته نرخ نامه', path: PATH_DASHBOARD.general.transactionPackageList(projectId) },
              { title: 'پاداش مشاهده ویدیو', path: PATH_DASHBOARD.general.mediaRewards(projectId) },

              { title: 'هزینه و پاداش بازی ها', path: PATH_DASHBOARD.general.gameFeeList(projectId) },
              { title: 'ترازو', path: PATH_DASHBOARD.general.exchangeList(projectId) },
              { title: 'آواتارها', path: PATH_DASHBOARD.general.avatarList(projectId) },
              { title: 'نظرات', path: PATH_DASHBOARD.general.commentList(projectId) },
              { title: 'پاداش کاربران', path: PATH_DASHBOARD.general.profileRewardList(projectId) },
              // { title: 'پاداش بازی ها', path: PATH_DASHBOARD.general.gameEntryFeeRewards(projectId) },
              { title: 'پخش زنده (vod)', path: PATH_DASHBOARD.general.rtmpList(projectId) },
              { title: 'پخش زنده (rtmp)', path: PATH_DASHBOARD.general.rtmpAppList(projectId) },
              { title: 'پخش مدیا', path: PATH_DASHBOARD.general.mediaSocialPlayerList(projectId) },
            ],
          }),
          ...(item?.ProfileUACMenuUrl === '/dashboard/financial-management' && {
            children: [
              { title: 'درگاه های پرداخت', path: PATH_DASHBOARD.general.gatewayList() },
              { title: 'درگاه پرداخت پروژه ها', path: PATH_DASHBOARD.general.gatewayProfileList() },
              { title: 'تنظیم درگاه پروژه', path: PATH_DASHBOARD.general.gatewayJoinProfileList() },
              { title: 'گزارش های مالی', path: PATH_DASHBOARD.general.financialReports },
            ],
          }),
          ...(item?.ProfileUACMenuUrl === '/dashboard/common-sections' && {
            children: [
              { title: 'انواع واحدهای پرداخت', path: PATH_DASHBOARD.general.transactionAmountTypeList },
              { title: 'انواع بسته های اشتراک', path: PATH_DASHBOARD.general.subscribePackageTypeList },
              { title: 'جایگاه بسته های اشتراک', path: PATH_DASHBOARD.general.subscribePackagePositionList },
              { title: 'انواع فریم اعلان ها', path: PATH_DASHBOARD.general.notificationStyleList },
              { title: 'انواع مدل کسب و کار', path: PATH_DASHBOARD.general.productType },
            ],
          }),
          ...(item?.ProfileUACMenuUrl === '/dashboard/footballop' && {
            children: [
              { title: 'کارت های بازی', path: PATH_DASHBOARD.general.gameCardList() },
              { title: 'زمین های بازی', path: PATH_DASHBOARD.general.gamePlanetList() },
              { title: 'کدهای هدیه', path: PATH_DASHBOARD.general.giftCodeList() },
            ],
          }),
          ...(item?.ProfileUACMenuUrl === '/dashboard/social-manager' && {
            children: [
              { title: 'حساب های کاربری', path: PATH_DASHBOARD.general.socialManagerAccountList() },
              { title: 'کانال ها', path: PATH_DASHBOARD.general.socialManagerChannelList() },
              { title: 'محتوا ها', path: PATH_DASHBOARD.general.socialManagerContentList() },
            ],
          }),
        };
      }),
    },
  ];

  return (
    <Box {...other}>
      {manipulatedNavConfig?.map((group) => (
        <List key={group.subheader} disablePadding sx={{ px: 2 }}>
          {/* <ListSubheaderStyle
            sx={{
              ...(isCollapse && {
                opacity: 0,
              }),
            }}
          >
            {group.subheader}
          </ListSubheaderStyle> */}

          {group.items.map((list, index) => (
            <NavListRoot
              key={list.title}
              list={list}
              isCollapse={isCollapse}
              showExitProjectButton={menuItems[2]?.ProfileUACMenuTitle?.includes('پروژه') && index === 2}
            />
          ))}
        </List>
      ))}
    </Box>
  );
}
